import { Typography } from '@ori-ui/mui';
import type { FC } from 'react';
import { memo } from 'react';

import { ShadeElement } from './ShadeElement';
import { Root } from './styles';
import type { ShadeProps } from './types';

export const Shade: FC<ShadeProps> = memo(({ 'data-testid': testId, colorName, ...shadeElementProps }) => (
  <Root data-testid={testId}>
    <ShadeElement {...shadeElementProps} />
    <Typography variant="caption">{colorName}</Typography>
  </Root>
));
